// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.teacher-home-wrapper {
  height: 64vh;
  width: 100%;
}
.teacher-home-wrapper .section-container {
  border-radius: 10px;
  background-color: #676666;
  padding: 16px 24px;
  width: 100%;
}
.teacher-home-wrapper .section-container .sub-section-line {
  background-color: #EDEDED;
  color: #EDEDED;
  height: 1px;
  margin: 16px 0px;
}
.teacher-home-wrapper .section-container .released-status-container {
  border-radius: 10px;
  background-color: #EDEDED;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
}
.teacher-home-wrapper .section-container .released-status-container .grades-ready-title {
  font-weight: bold;
  margin-bottom: 8px;
}
.teacher-home-wrapper .section-container .released-status-container .released-grades-list {
  color: #444343;
}
.teacher-home-wrapper .section-container .released-status-container .released-grades-list span {
  color: #0669B3;
}
.teacher-home-wrapper .section-container .released-status-container .no-grades-released {
  background-color: #EDEDED;
  border: 1px solid #EDEDED;
  border-radius: 8px;
  color: #444343;
  font-style: italic;
  padding: 10px;
  text-align: center;
}
.teacher-home-wrapper .section-container.top {
  height: 40%;
  margin-bottom: 3%;
}
.teacher-home-wrapper .section-container.bottom {
  height: 55%;
}
.teacher-home-wrapper .sub-section-title {
  align-items: flex-end;
  color: white;
  display: flex;
  font-size: 19.2px;
  font-weight: 700;
  justify-content: space-between;
}

.right-side-wrapper {
  position: relative;
  background-color: #EDf0F1;
  border-radius: 10px;
  margin-bottom: 32px;
  min-height: 300px;
  padding: 24px;
  width: 100%;
}
.right-side-wrapper .helper-text {
  margin: 24px 0px;
}
.right-side-wrapper .right-page-title {
  color: #0669B3;
  font-weight: 700;
  margin-bottom: 24px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/TeacherHome.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,YAAA;EACA,WAAA;AAUJ;AARI;ECJA,mBDK0B;EACtB,yBAAA;EACA,kBAAA;EACA,WAAA;AAUR;AARQ;EACI,yBDEJ;ECDI,cDCJ;ECAI,WAAA;EACA,gBAAA;AAUZ;AAPQ;ECjBJ,mBDkB8B;EACtB,yBDNJ;ECOI,0CAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;AASZ;AARY;EACI,iBAAA;EACA,kBAAA;AAUhB;AARY;EACI,cDFP;ACYT;AATgB;EACI,cDHP;ACcb;AANY;EACI,yBDzBR;EC0BQ,yBAAA;EACA,kBAAA;EACA,cDbP;ECcO,kBAAA;EACA,aAAA;EACA,kBAAA;AAQhB;AAHI;EACI,WAAA;EACA,iBAAA;AAKR;AAFI;EACI,WAAA;AAIR;AADI;EACI,qBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;AAGR;;AACA;EACI,kBAAA;EACA,yBDhDI;ECiDJ,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,WAAA;AAEJ;AAAI;EACI,gBAAA;AAER;AACI;EACI,cDrDK;ECsDL,gBAAA;EACA,mBAAA;AACR","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.teacher-home-wrapper {\n    height: 64vh;\n    width: 100%;\n\n    .section-container {\n        @include borderRadius(10px);\n        background-color: #676666;\n        padding: 16px 24px;\n        width: 100%;\n\n        .sub-section-line {\n            background-color: $white;\n            color: $white;\n            height: 1px;\n            margin: 16px 0px;\n        }\n\n        .released-status-container {\n            @include borderRadius(10px);\n            background-color: $white;\n            box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n            display: flex;\n            flex-direction: column;\n            gap: 10px;\n            padding: 20px;\n            .grades-ready-title {\n                font-weight: bold;\n                margin-bottom: 8px;\n            }\n            .released-grades-list {\n                color: $grey4a;\n                span {\n                    color: $pearl-blue;\n                }\n            }\n\n\n            .no-grades-released {\n                background-color: $white;\n                border: 1px solid $white;\n                border-radius: 8px;\n                color: $grey4a;\n                font-style: italic;\n                padding: 10px;\n                text-align: center;\n            }\n        }\n    }\n\n    .section-container.top {\n        height: 40%;\n        margin-bottom: 3%;\n    }\n\n    .section-container.bottom {\n        height: 55%;\n    }\n\n    .sub-section-title {\n        align-items: flex-end;\n        color: white;\n        display: flex;\n        font-size: 19.2px;\n        font-weight: 700;\n        justify-content: space-between;\n    }\n}\n\n.right-side-wrapper {\n    position: relative;\n    background-color: $grey0;\n    border-radius: 10px;\n    margin-bottom: 32px;\n    min-height: 300px;\n    padding: 24px;\n    width: 100%;\n\n    .helper-text {\n        margin: 24px 0px;\n    }\n\n    .right-page-title {\n        color: $pearl-blue;\n        font-weight: 700;\n        margin-bottom: 24px;\n    }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
